import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {CollaborationState} from "../../store/collaboration.reducer";
import {Store} from "@ngrx/store";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import {CollaborationConfig} from "../../store/collaboration.config";
import {CollaborationQuery} from "../../store/collaboration.query";
import {getConversationList} from "../../store/collaboration.selector";
import {DeleteConversationListAction, GetConversationListAction} from "../../store/collaboration.action";
import {ConversationListComponentName} from "../../store/collaboration.constants";
import {SetCurrentRightSideComponentAction} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {DeleteConversationCommand} from "../../store/collaboration.command";
import {DialogModel} from "@shared/models/dialog.model";
import {DialogService} from "@shared/services/dialog-service";

@Component({
    standalone: false,
    selector: 'particle-edit-conversation-list',
  templateUrl: './edit-conversation-list.component.html',
  styleUrls: ['./edit-conversation-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditConversationListComponent implements OnInit {

  conversationList$: any;
  conversationList: any;
  selectedConversationIds = [];
  constructor (private collaborationStore: Store<CollaborationState>, private platformSidebarStore: Store<PlatformSidebarState>, private dialogService: DialogService) {
    this.selectedConversationIds = [];
  }

  ngOnInit () {
    this.getConversationList();
    this.subscribeToConversationList();
  }

  getConversationList () {
    this.collaborationStore.dispatch(new GetConversationListAction(CollaborationConfig.CollaborationApiKey,
      CollaborationQuery.getConversationList()));
  }

  subscribeToConversationList () {
    this.conversationList$ = this.collaborationStore.select(getConversationList);
    this.conversationList$.subscribe(conversationList => {
      this.conversationList = conversationList;
      if(this.conversationList && this.conversationList.length) {
        this.conversationList.forEach(conversation => {
          conversation.isSelected = false;
        });
      }
    });
  }
  onSelectionChange(event) {
    this.selectedConversationIds = [];
    console.log('event:', event);
    this.conversationList.forEach(conversation => {
      if (conversation.isSelected === true) {
        this.selectedConversationIds.push(conversation.id);
      }
    });
    console.log('selected conversation ids:', this.selectedConversationIds);
  }
  deleteConversations() {
    console.log(this.selectedConversationIds, this.selectedConversationIds.length);
    const dialogModel: DialogModel = DialogModel.create(
      'Delete',
      'DeleteConversationsDialogComponent', { 'numberOfConversationIds': this.selectedConversationIds.length },
      '500px',
      '500px'
    );
    dialogModel.okCaption = 'Delete';
    dialogModel.cancelCaption = 'Cancel';
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log('res:', res);
      if (res.action === 'OK') {
        console.log('ff', new DeleteConversationCommand(this.selectedConversationIds));
        this.collaborationStore.dispatch(new DeleteConversationListAction(new DeleteConversationCommand(this.selectedConversationIds)));
      }
    });
    }

  navigateToConversationList() {
    this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction({component: ConversationListComponentName, data: {}, componentInfo: null}));
   }

}
